// resizing select element widths based on selected option
( function() {
	const resizeSelects = document.querySelectorAll( 'select.resizeselect' );

	resizeSelects.forEach( function( select ) {
		select.addEventListener( 'change', function() {
			var selectedOption = this.querySelector( 'option:checked' );

			// Create a clone of the select that just changed
			var cloneEle = this.cloneNode( true );

			// Remove all but the selected option
			for( var i = cloneEle.options.length - 1; i >= 0; i-- ) {
				if( !cloneEle.options[i].isEqualNode( selectedOption ) ) {
					cloneEle.removeChild( cloneEle.options[i] );
				}
			}

			// Set the width to auto, so it will adopt the width of the remaining option
			cloneEle.style.width = 'auto';

			// Append it to the document in order to get the width
			this.parentElement.append( cloneEle );

			var width = cloneEle.getBoundingClientRect().width;

			// Remove it, no longer needed
			this.parentElement.removeChild( cloneEle );

			// Use that width to set the select that just changed
			if( width > 0 ) {
				this.style.width = width + 'px';
			}
		} );
		this.dispatchEvent( new Event( 'change' ) ); // run on start

	} );
	
} )();